/**
 * Генерирует url страницы авторизации для дальнейшего редиректа после входа в систему
 * @param url адрес, куда будет выполнен редирект. Если не указан, то используется `location.pathname`
 * @returns url-адрес
 */
export function generateAuthUrlFor(url = "") {
	return `/main?backUrl=${encodeURI(url || location.pathname)}`
}
